import { motion } from "framer-motion";
import { Reveal, KineticLines } from "./Reveal";
import { MANIFESTO, IMAGES } from "../../data";

export default function About() {
  return (
    <section
      id="about"
      className="relative bg-ink py-24 md:py-36 px-6 lg:px-10"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="font-body text-xs md:text-sm uppercase tracking-[0.3em] text-teal mb-6">
                / The Manifesto
              </p>
            </Reveal>
            <h2 className="font-display font-700 uppercase leading-[0.9] tracking-tighter text-white text-5xl md:text-6xl lg:text-7xl">
              <KineticLines lines={["More than", "a gym."]} />
            </h2>
            <Reveal delay={0.15}>
              <p className="mt-8 max-w-xl font-body text-base md:text-lg text-neutral-300 leading-relaxed">
                War Room Performance is St. Augustine's only authentic Muay Thai
                school — where sweat meets purpose. We build fighters and
                disciples of discipline in a room that stays clean, humble, and
                relentlessly professional.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.2} className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-lg border border-white/10 aspect-[4/5]">
              <img
                src={IMAGES.heroFloor}
                alt="Inside the War Room"
                className="h-full w-full object-cover grayscale hover:grayscale-0 transition-[filter] duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
            </div>
          </Reveal>
        </div>

        <div className="mt-20 md:mt-28 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-lg overflow-hidden">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: i * 0.12 }}
              className="group bg-[#121212] p-8 md:p-10 hover:bg-[#161616] transition-colors duration-500"
              data-testid={`manifesto-${m.n}`}
            >
              <span className="font-display text-5xl md:text-6xl text-stroke group-hover:text-stroke-pink transition-all duration-500">
                {m.n}
              </span>
              <h3 className="mt-6 font-display uppercase tracking-tight text-2xl text-white">
                {m.title}
              </h3>
              <p className="mt-4 font-body text-sm md:text-base text-neutral-400 leading-relaxed">
                {m.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
